// extracted by mini-css-extract-plugin
module.exports = {"main":"RegisterHeader_main__rscTV","background":"RegisterHeader_background__3DDJO"};